/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessType } from '../../models/access-type';
import { TokenResponseModel } from '../../models/token-response-model';

export interface AuthenticationGetFullAccess$Params {
  accessType?: AccessType;
  insurerId?: string;
  cardId?: string;
  dob?: string;
}

export function authenticationGetFullAccess(http: HttpClient, rootUrl: string, params?: AuthenticationGetFullAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenResponseModel>> {
  const rb = new RequestBuilder(rootUrl, authenticationGetFullAccess.PATH, 'get');
  if (params) {
    rb.query('accessType', params.accessType, {});
    rb.query('insurerId', params.insurerId, {});
    rb.query('cardId', params.cardId, {});
    rb.query('dob', params.dob, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenResponseModel>;
    })
  );
}

authenticationGetFullAccess.PATH = '/v1/Authentication/GetFullAccess';
